import { QualifiedSharedDividendReportActionTypes } from "models/actionTypes/qualifiedSharedDividendsActionTypes";
import { ReduxConstants } from "utils/constants";

export const qualifiedSharedDividendsReportAccepted = (id: string): QualifiedSharedDividendReportActionTypes => {
  return {
    type: ReduxConstants.QualifiedSharedDividendsActions.QUALIFIED_SHARED_DIVIDENDS_REPORT_ACCEPTED,
    payload: id,
  };
};

export const qualifiedSharedDividendsReportRejected = (id: string): QualifiedSharedDividendReportActionTypes => {
  return {
    type: ReduxConstants.QualifiedSharedDividendsActions.QUALIFIED_SHARED_DIVIDENDS_REPORT_REJECTED,
    payload: id,
  };
};

export const qualifiedSharedDividendsReportSnoozed = (id: string): QualifiedSharedDividendReportActionTypes => {
  return {
    type: ReduxConstants.QualifiedSharedDividendsActions.QUALIFIED_SHARED_DIVIDENDS_REPORT_SNOOZED,
    payload: id,
  };
};
